<template>
  <authenticated-layout
    :back-route="{
      name: 'schoolsDashboardWithTenant',
      params: { tenantId: tenant?._id, tab: 'licenses' }
    }"
    :breadcrumbs="breadcrumbItems"
  >

    <AccessCodeDetailContent
      @access-code-loaded="onAccessCodeLoaded"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {onMounted, ref, computed} from "vue";
import {AccessCode, Tenant} from "@YenzaCT/sdk";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import AccessCodeDetailContent from "@/components/AccessCodeDetail/AccessCodeDetailContent.vue";
import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";
import {useRoute} from "vue-router";

const route = useRoute();
const {executeApi} = useApiCall();

const tenantId = route.params.tenantId as string;

const accessCode = ref<AccessCode>();
const tenant = ref<Tenant>();

const breadcrumbItems = computed(() => [
  {
    text: "My Schools",
    to: {name: "schoolsDashboard"}
  },
  {
    text: tenant.value?.title || "Tenant",
    to: {
      name: "schoolsDashboardWithTenant",
      params: {tenantId: tenant.value?._id, tab: "licenses"}
    }
  },
  {
    text: accessCode.value?.code ? `License #${accessCode.value.code}` : "License Details"
  }
]);

async function fetchTenant() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.tenant.get(tenantId);
    return response.data;
  });
  if (result) {
    tenant.value = result;
  }
}

function onAccessCodeLoaded(loadedAccessCode: AccessCode) {
  accessCode.value = loadedAccessCode;
}

onMounted(async () => {
  await fetchTenant();
});
</script>
